var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEssyLogoSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 85,
    viewBox: "0 0 71 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.2332 57.7142L32.6684 38.1494L24.7752 46.0426L44.34 65.6074L52.2332 57.7142Z",
    fill: "#FCE80F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.34 65.6083L71 38.9482L63.1068 31.055L36.4468 57.7151L44.34 65.6083Z",
    fill: "#FF6633"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4849 58.3376L39.1449 84.9976L47.0381 77.1044L20.3781 50.4444L12.4849 58.3376Z",
    fill: "#764AFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89318 53.7464L34.5532 27.0864L26.66 19.1932L1.2581e-06 45.8533L7.89318 53.7464Z",
    fill: "#29B8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1558 7.8932L50.8158 34.5532L58.709 26.66L32.049 2.1043e-06L24.1558 7.8932Z",
    fill: "#28DDCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEssyLogoSimple);
export default __webpack_public_path__ + "static/media/essy-logo-simple.c9141ee033a5c4e6c3587f6f8468a2b8.svg";
export { ForwardRef as ReactComponent };